import { SVGProps } from 'react';

export const ArrowDownBig = ({ width = 24, height = 24, fill = '#1F2023', strokeWidth = 2 }: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 9L12 17L4 9" stroke={fill} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
